<template>
  <CustomModal ref="modal" class="company-tva-regime-modal" title="Modifier le régime TVA">
    <CustomForm ref="form" :inputs="inputs" :submit="buttons.save">

      <div class="container">

        <div class="current-info">
          <h3>Paramètres actuels</h3>

          <div class="info">
            <span class="label">Régime TVA</span>
            <span>{{vatRegimeLabel}}</span>
          </div>

          <div class="info">
            <span class="label">TVA sur les débits</span>
            <span>{{companyInfo?.has_vat_on_debits ? "Oui" : "Non"}}</span>
          </div>
        </div>

        <div class="fields">
          <CustomRadioField :content="inputs.vatRegime"/>

          <CustomCheckboxField
              label="TVA sur les débits"
              :selected="{value:true,label:'Oui'}"
              :other="{value:false,label:'Non'}"
              ref="vatOnDebits"
          />
        </div>

      </div>

      <div class="footer">
        <CustomButton style="width: 200px" :params="buttons.save" @click="save"/>
      </div>

    </CustomForm>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/modals/CustomModal.vue";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomRadioField from "@/components/forms/customs/customRadioField/CustomRadioField.vue";
import CustomCheckboxField from "@/components/forms/customs/customCheckboxField/CustomCheckboxField.vue";
import {NotificationService} from "@vues/v-common";
import {CompanyController} from "@/invoice-transmission/controllers/invoice_transmission/CompanyController";

export default {
  name:"CompanyTvaRegimeModal",
  props:["callback"],
  components:{CustomModal,CustomForm,CustomButton,CustomRadioField,CustomCheckboxField},
  data(){
    return {
      companyInfo:undefined,

      buttons:{
        save:{text:"Enregistrer"}
      },

      inputs:{
        vatRegime:{
          label:"Régime TVA",
          name:"vatRegime",
          value:"",
          values:[
            {value:"monthly",label:"Réel normal mensuel"},
            {value:"quarterly",label:"Réel normal trimestriel"},
            {value:"simplified",label:"Réel simplifié"},
            {value:"vat_exemption",label:"Franchise en base de TVA"}
          ]
        }
      }
    };
  },
  computed:{
    vatRegimeLabel(){
      const regime=this.inputs.vatRegime.values.find(item=>item.value===this.inputs.vatRegime.value);
      return regime?.label || "-";
    }
  },
  methods:{
    async openModal(companyInfo){
      this.companyInfo=companyInfo;

      this.inputs.vatRegime.value=companyInfo?.vat_regime || "";

      this.$refs.modal.openModal();
    },
    closeModal(){
      this.$refs.modal.closeModal();
    },
    async save(){
      this.$refs.form?.startLoading();

      const hasVatOnDebits=this.$refs.vatOnDebits.selectedValue.value;

      const resp=await CompanyController.putTvaRegime(
          this.inputs.vatRegime.value,
          hasVatOnDebits
      );

      this.$refs.form?.stopLoading();

      if(resp.errors)
        return;

      (new NotificationService()).addNotification("success","Paramètres TVA enregistrés.");

      this.closeModal();

      if(this.callback)
        this.callback(resp);
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.container
  display flex
  flex-direction column
  gap 25px

.current-info
  background #f5f5f5
  padding 15px
  border-radius 8px
  display flex
  flex-direction column
  gap 10px

.current-info h3
  margin 0 0 5px

.info
  display flex
  flex-direction column
  gap 3px

.label
  font-size 12px
  text-transform uppercase
  color #888
  font-weight 600

.fields
  display flex
  flex-direction column
  gap 20px

.footer
  display flex
  justify-content center
  margin-top 20px
</style>

<style lang="stylus">
.company-tva-regime-modal .modal
  width 600px !important
</style>